import api from "../..";
import type { GetPayoutsParams, GetPayoutsResponse } from "./types";

export const getPayouts = async (input: GetPayoutsParams = {}): Promise<GetPayoutsResponse[]> => {
  const { params } = input;

  return await api.get("/payments/payout/", { params })
  .then(res => res.data.data)
  .catch(() => {return []});
};
